module.exports = __webpack_public_path__ + "static/media/3.5853bb40.jpeg";